import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import RouteMap from 'es/app/views/system/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router';

const Facilities = lazy(() => import('es/app/views/system/facilities'));
const EditFacilities = lazy(() => import('es/app/views/system/facilities/edit'));
const EditFacilityForm = lazy(() => import('es/app/views/system/facilities/edit/details'));
const FacilityUsers = lazy(() => import('es/app/views/system/facilities/edit/users/FacilityUsers'));
const EditFacilityFeatureFlags = lazy(() => import('es/app/views/system/facilities/edit/feature-flags'));

export function FacilityRoutes() {
    return (
        <Route path={RouteMap.facilities.search()} element={<Facilities />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={RouteMap.facilities.create()} element={<EditFacilities />}>
                <Route index element={<EditFacilityForm />} />
            </Route>
            <Route path={RouteMap.facilities.edit().root} element={<EditFacilities />}>
                <Route index element={<EditFacilityForm />} />
                <Route path={RouteMap.facilities.edit().users} element={<FacilityUsers />} />
                <Route path={RouteMap.facilities.edit().features} element={<EditFacilityFeatureFlags />} />
            </Route>
        </Route>
    );
}
